/**
 * utility to create a range spanning the contents of the given element.
 */
function createRangeFromNodeContent(element) {
  if (!element) {
    return;
  }
  const range = document.createRange();
  range.selectNodeContents(element);
  return range;
}

export { createRangeFromNodeContent };
//# sourceMappingURL=createRangeFromNodeContent.js.map
